import { useState } from "react";
import { useNavigate } from "react-router-dom";
import OnboardingIntroduction from "./onboardingStepOne";
import OnboardingSurvey from "./onboardingSurvey";
import OnboardingWebsite from "./onboardingStepThree";
import OnboardingChrTargeting from "./onboardingChrTargeting";
import OnboardingSiteAnalyse from "./onboardingStepFour";

const Onboarding = () => {
    const nav = useNavigate();
    const [step, setStep] = useState("intro");
    
    return (
        <>
            {step === "intro" && (
                <OnboardingIntroduction onNext={() => setStep("prospecting-methods")} />
            )}
            {step === "prospecting-methods" && (
                <OnboardingSurvey onNext={() => setStep("enrichment-tools")} />
            )}
            {step === "enrichment-tools" && (
                <OnboardingWebsite
                    onNext={() => setStep("chr-targeting")}
                    onPrev={() => setStep("prospecting-methods")}
                />
            )}
            {step === "chr-targeting" && (
                <OnboardingChrTargeting
                    onNext={() => setStep("challenges")}
                    onPrev={() => setStep("enrichment-tools")}
                />
            )}
            {step === "challenges" && (
                <OnboardingSiteAnalyse
                    onNext={() => nav("/signals")}
                    onPrev={() => setStep("chr-targeting")}
                />
            )}
        </>
    );
};
export default Onboarding;
